import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
import {
  examInCoreLoading,
  examInCoreSettingsSelector,
  saveExamInCoreSettings,
} from 'slices/examInCoreSettings.slice';
import { useAppDispatch } from 'slices/store';
import { Button, DefaultContentLayout } from '@timeedit/ui-components';
import ExamInCoreConfiguration from '../../../components/AppService/ExamInCoreConfiguration/ExamInCoreConfiguration';
import intl from '../../../i18n/intl';

const language: any = intl.messages;

const ExamInCorePage = () => {
  const dispatch = useAppDispatch();
  const appSettings = useSelector(examInCoreSettingsSelector);
  const loading = useSelector(examInCoreLoading);

  const onSave = () => {
    dispatch(saveExamInCoreSettings(appSettings.examInCore));
  };

  return (
    <DefaultContentLayout
      title={language.application_exam_setting_title}
      subtitle={language.application_exam_in_core_subtitle}
      actions={
        <Button type="primary" onClick={onSave}>
          {language.save_changes as string}
        </Button>
      }
    >
      <LoadingWrapper isLoading={loading}>
        <ExamInCoreConfiguration appSettings={appSettings} />
      </LoadingWrapper>
    </DefaultContentLayout>
  );
};

export default ExamInCorePage;
